import { fromEventPattern } from 'rxjs';
import { EventEmitter } from 'events';
import { startWith, shareReplay } from 'rxjs/operators';
export class IM_CurrentSession {
    constructor() {
        this.myEvent = new EventEmitter();
        this.sdk = null;
        const { onCurrSessionId: eventName } = IM_CurrentSession.Event_Name_Collections;
        const onCurrSessionId = (handler) => {
            this.myEvent.addListener(eventName, handler);
        };
        const offCurrSessionId = (handler) => {
            this.myEvent.removeListener(eventName, handler);
        };
        const $event = fromEventPattern(onCurrSessionId, offCurrSessionId);
        this.subject = $event.pipe(startWith(''), shareReplay(1));
    }
    getSubject() {
        return this.subject;
    }
    init(sdk) {
        this.sdk = sdk;
    }
    async setSession(options, { validateTeam = false, tryCreateSession = false, }) {
        options = Object.assign({ scene: options.scene || 'p2p' }, options);
        await this._isTeamValid(options.to, validateTeam ? options.scene : 'p2p');
        if (tryCreateSession) {
            await this._getSessionById(options.to, options.scene);
        }
        const { onCurrSessionId: eventName } = IM_CurrentSession.Event_Name_Collections;
        this.myEvent.emit(eventName, [options.scene, options.to].join('-'));
        return true;
    }
    async setPushSessionEvent(options) {
        const { onCurrSessionId: eventName } = IM_CurrentSession.Event_Name_Collections;
        this.myEvent.emit(eventName, [options.scene, options.to].join('-'));
    }
    createSession(scene, to) {
        this._getSessionById(to, scene);
    }
    async _getSessionById(to, scene) {
        try {
            const session = (await this.sdk.excute('getLocalSession', {
                sessionId: [scene, to].join('-'),
            }));
            if (['scene', 'to', 'updateTime'].every(key => Reflect.has(session, key))) {
                return session;
            }
            throw new Error('invalid session');
        }
        catch (ex) { }
        try {
            const { session } = (await this.sdk.excute('insertLocalSession', {
                scene,
                to,
            }));
            return session;
        }
        catch (ex) { }
        const msg = (await this.sdk.excute('sendText', {
            scene,
            to,
            text: 'CREATE_CONVERSATION_MSG',
            isLocal: true,
        }));
        await this.sdk.excute('deleteLocalMsg', {
            msg,
        });
        return this.sdk.excute('getLocalSession', {
            sessionId: [scene, to].join('-'),
        });
    }
    async _isTeamValid(to, scene = 'team') {
        if (scene !== 'team') {
            return Promise.resolve(true);
        }
        await this.sdk.excute('getTeam', { teamId: to });
        return Promise.resolve(true);
    }
}
IM_CurrentSession.Event_Name_Collections = {
    onCurrSessionId: 'onCurrSessionId',
};
